module.exports = __webpack_public_path__ + "static/media/Cascade_Badge.56a6ec88.png";